export default ['$q', 'JsonRPCService', 'policyjob.endpointConfig', 'policyjob.xCenterRouteConfig', function ($q, JsonRPCService, endpointConfig, xCenterRouteConfig) {

    var xCenterRoute = xCenterRouteConfig;
    var endpoint = endpointConfig.availability;

    return {
        checkAvailabilityBasedOnPostalCode: function checkAvailabilityBasedOnPostalCode(availabilityRequestDTO) {
            var deferred = $q.defer();
            JsonRPCService.send(xCenterRoute, endpoint, 'isProductAvailableBasedOnPostalCode', [availabilityRequestDTO]).then(function (availabilityResponseDTO) {
                return deferred.resolve(availabilityResponseDTO);
            }, function (error, status, headers) {
                return deferred.reject([error, status, headers]);
            });
            return deferred.promise;
        },

        checkAvailabilityBasedOnAddress: function checkAvailabilityBasedOnAddress(availabilityRequestDTO) {
            var deferred = $q.defer();
            JsonRPCService.send(xCenterRoute, endpoint, 'isProductAvailableBasedOnAddress', [availabilityRequestDTO]).then(function (response) {
                var availabilityResponseDTO = response;
                return deferred.resolve(availabilityResponseDTO);
            }, function (error, status, headers) {
                return deferred.reject([error, status, headers]);
            });
            return deferred.promise;
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/policyjob/services/AvailabilityService.js
// module id = 1196
// module chunks = 0